import { Type } from '@sinclair/typebox';
import { SupportedNetworkSchema } from '../supported-network.js';
import { TokenSocailsSchema } from '../token/token-meta-extended.js';
import { TokenModerationReasonSchema, TokenModerationStatusSchema, } from '../token/token-moderation.js';
export const PoolTokenSchema = Type.Object({
    address: Type.String(),
    name: Type.String(),
    symbol: Type.String(),
    decimals: Type.Number(),
    logo: Type.String(),
    supply: Type.String(),
    network: SupportedNetworkSchema,
    tokenProgram: Type.Optional(Type.String()),
    isRenounced: Type.Optional(Type.Boolean()),
    socials: Type.Optional(TokenSocailsSchema),
    status: TokenModerationStatusSchema,
    moderationReason: Type.Optional(TokenModerationReasonSchema),
    imageHash: Type.Optional(Type.String({
        description: 'Perceptual dHash of the token logo (64-bit hex)',
    })),
    reusedImageCount: Type.Optional(Type.Number({
        description: 'Number of other tokens sharing the same logo image',
    })),
    updatedAt: Type.Optional(Type.String()),
});
//# sourceMappingURL=pool-token.js.map